import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { LIVE_CHAT_ANCHOR_ID } from 'lib/liveChat';
import { useLiveChatClickHandler } from './lib/useLiveChatClickHandler';

const Anchor = styled.span`
  position: fixed;
  bottom: 0;
  width: 100%;

  @media print {
    display: none;
  }

  .embeddedServiceHelpButton .helpButton .uiButton,
  .embeddedServiceSidebar .embeddedServiceSidebarMinimizedDefaultUI {
    background-color: ${themeGet('colors.brand.primary')};
    border-color: ${themeGet('colors.brand.primary')};
    font-family: ${themeGet('fontFamily')};
    font-size: ${themeGet('fontSizes.sm')};

    &:focus {
      text-decoration: none;
    }

    .embeddedServiceIcon {
      display: none !important;
    }
  }

  .embeddedServiceHelpButton .helpButton .uiButton.helpButtonDisabled {
    background-color: #323232;
    opacity: 0.7;
    cursor: not-allowed;
  }

  .embeddedServiceHelpButton .helpButton .uiButton {
    transform: translate(0, 150%);
    transition: transform ${themeGet('transitions.quickFadeIn')};
  }

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    .embeddedServiceSidebar .embeddedServiceSidebarMinimizedDefaultUI {
      position: fixed;
      bottom: 12px;
      right: 12px;
      height: 46px;
      border-radius: 23px;
      width: 14em;
    }
  }
`;

export const LiveChatAnchor = () => {
  useLiveChatClickHandler();

  return <Anchor id={LIVE_CHAT_ANCHOR_ID} />;
};

LiveChatAnchor.displayName = 'LiveChatAnchor';
